import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './LoginBtn.css';
import React, { useEffect, useState, useContext } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { IconToggleArrowDown } from '../../components/atoms/Icons';
import { ReactComponent as Logout } from '../../resources/icons/logout.svg';
import { getUserCookie, logoutUser } from '../Login/user_session';
// import { Link } from 'react-router-dom';
// import { RouterLink as Link } from 'react-router-dom';
import RouterLink from '../atoms/RouterLink';
import { canUseDOM, isChina } from '../../utils';
import { get, getDictionaryItem } from '../../utils';
var LoginBtn = function LoginBtn(_ref) {
  var accountLinks = _ref.accountLinks,
    dictionary = _ref.dictionary,
    analyticsClick = _ref.analyticsClick,
    closeNav = _ref.closeNav,
    isMobileView = _ref.isMobileView,
    userProfile = _ref.userProfile;
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var lang = sitecoreContext && sitecoreContext.language;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loginState = _useState2[0],
    setLoginState = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    mobOpenState = _useState4[0],
    setMobOpenState = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    userName = _useState6[0],
    setUserName = _useState6[1];
  var linksArray = get(accountLinks, 'targetItem.links');
  // const dictionaryArray = get(dictionary, 'targetItem.links');
  var editProfile = linksArray && linksArray[0];
  var Login = linksArray && linksArray[2];

  /* const eventCalendar = linksArray && linksArray[1]; */
  var myAccount = linksArray && linksArray[3];
  var ticketPurchase = linksArray && linksArray[5];
  var topPicks = linksArray && linksArray[6];
  // const dictionaryValues: any = { dictionaryValues: [...dictionary] };
  var logoutCopy = getDictionaryItem(dictionary && dictionary.dictionary, 'Logout');
  var loginHref = get(Login, 'link.jss.value.href');
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    usernameArabic = _useState8[0],
    setUsernamearabic = _useState8[1];
  useEffect(function () {
    var user = '';
    if (userProfile) {
      var firstName = userProfile.firstName,
        lastName = userProfile.lastName,
        email = userProfile.email;
      if (firstName && firstName.length || lastName && lastName.length) {
        user = "".concat(firstName ? firstName + ' ' : '').concat(lastName ? lastName : '');
      } else {
        user = "".concat(email ? email : '');
      }
      if (isArabic(user)) {
        setUsernamearabic(true);
      }
      setUserName(user);
      setLoginState(true);
    }
  }, [userProfile]);
  var isArabic = function isArabic(text) {
    var arabic = /[\u0600-\u06FF]/;
    var result = arabic.test(text);
    return result;
  };
  if (!loginHref) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, !isChina() ? /*#__PURE__*/React.createElement("div", {
    className: "login-element-wrapper ".concat(loginState ? 'login-element-wrapper--logged-in' : '')
  }, loginState ? /*#__PURE__*/React.createElement("span", {
    className: "header-tr__link--logged-in header-tr__link header-tr__link-login ".concat(mobOpenState ? 'header-tr__link-login--open' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-tr__link-inner",
    onClick: function onClick() {
      setMobOpenState(!mobOpenState);
      if (analyticsClick) {
        analyticsClick();
      }
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: get(Login, 'icon.jss.value.src'),
    className: "login-icon ",
    alt: get(Login, 'title.jss.value')
  }), /*#__PURE__*/React.createElement("span", {
    className: "username ".concat(usernameArabic ? 'username--arabic' : ''),
    dir: "auto"
  }, userName), /*#__PURE__*/React.createElement("span", {
    className: "nav-link__arrow"
  }, /*#__PURE__*/React.createElement(IconToggleArrowDown, null))), /*#__PURE__*/React.createElement("div", {
    className: "login__dropdown"
  }, get(topPicks, 'link.jss.value.href') && /*#__PURE__*/React.createElement("div", {
    className: "login__dropdown-item"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "login__dropdown-link",
    href: get(topPicks, 'link.jss.value.href')
  }, /*#__PURE__*/React.createElement("span", {
    className: "login__dropdown-icon"
  }, /*#__PURE__*/React.createElement("img", {
    src: get(topPicks, 'icon.jss.value.src'),
    alt: get(topPicks, 'title.jss.value')
  })), get(topPicks, 'title.jss.value'))), get(ticketPurchase, 'link.jss.value.href') && /*#__PURE__*/React.createElement("div", {
    className: "login__dropdown-item"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "login__dropdown-link",
    href: get(ticketPurchase, 'link.jss.value.href'),
    onClick: function onClick() {
      if (closeNav && typeof closeNav === "function") {
        closeNav();
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "login__dropdown-icon"
  }, /*#__PURE__*/React.createElement("img", {
    src: get(ticketPurchase, 'icon.jss.value.src'),
    alt: get(ticketPurchase, 'title.jss.value')
  })), get(ticketPurchase, 'title.jss.value'))), get(myAccount, 'title.jss.value') && /*#__PURE__*/React.createElement("div", {
    className: "login__dropdown-item"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "login__dropdown-link",
    href: get(myAccount, 'link.jss.value.href'),
    onClick: function onClick() {
      if (closeNav && typeof closeNav === "function") {
        closeNav();
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "login__dropdown-icon"
  }, /*#__PURE__*/React.createElement("img", {
    src: get(myAccount, 'icon.jss.value.src'),
    alt: get(myAccount, 'title.jss.value')
  })), get(myAccount, 'title.jss.value'))), get(editProfile, 'title.jss.value') && /*#__PURE__*/React.createElement("div", {
    className: "login__dropdown-item"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "login__dropdown-link",
    href: get(editProfile, 'link.jss.value.href'),
    onClick: function onClick() {
      if (closeNav && typeof closeNav === "function") {
        closeNav();
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "login__dropdown-icon"
  }, /*#__PURE__*/React.createElement("img", {
    src: get(editProfile, 'icon.jss.value.src'),
    alt: get(editProfile, 'title.jss.value')
  })), get(editProfile, 'title.jss.value'))), /*#__PURE__*/React.createElement("div", {
    className: "login__dropdown-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "login__dropdown-link",
    onClick: function onClick() {
      if (canUseDOM) {
        var cookie = getUserCookie();
        if (cookie.login_status) {
          logoutUser().then(function (response) {
            if (response) {
              window.location.href = "".concat(lang ? "/".concat(lang) : '/');
            }
          });
        } else {
          window.location.href = "".concat(lang ? "/".concat(lang) : '/');
        }
        if (closeNav && typeof closeNav === "function") {
          closeNav();
        }
      }
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "login__dropdown-icon"
  }, /*#__PURE__*/React.createElement(Logout, null)), logoutCopy)))) : /*#__PURE__*/React.createElement(RouterLink, {
    className: "header-tr__link header-tr__link-login header-tr__link-inner",
    href: loginHref,
    onClick: function onClick() {
      if (closeNav && typeof closeNav === "function") {
        closeNav();
      }
      if (analyticsClick) {
        analyticsClick();
      }
    },
    ariaLabel: get(Login, 'title.jss.value')
  }, /*#__PURE__*/React.createElement("img", {
    src: get(Login, 'icon.jss.value.src'),
    className: "login-icon rs_skip",
    alt: "".concat(isMobileView ? 'mobile ' + get(Login, 'title.jss.value') : get(Login, 'title.jss.value') + " ".concat(Math.random().toFixed(2)))
  }), get(Login, 'title.jss.value'))) : null);
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: " ".concat(rtl ? rtlStyles : ltrStyles, " ").concat(commonStyles)
  }, children);
};
var commonStyles = "cbtx3uf";
var ltrStyles = "ll3unz8";
var rtlStyles = "r1ek9o2u";
export default LoginBtn;